import {getServiceNoticeQuery} from './get-service-notice.query'

export const ServiceNoticeQueries = {
  getServiceNoticeQuery,
}
